var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53516 11.4647L11.4294 4.5704C13.4797 2.52015 16.8039 2.52015 18.8541 4.5704C20.9044 6.62066 20.9041 9.94496 18.8539 11.9952L10.8989 19.9502C9.53209 21.317 7.31639 21.3168 5.94955 19.95C4.58272 18.5831 4.58238 16.3673 5.94922 15.0005L13.9042 7.0455C14.5876 6.36208 15.6962 6.36208 16.3796 7.0455C17.0631 7.72892 17.0626 8.83669 16.3792 9.52011L9.48486 16.4144",
    stroke: "#075A83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.72af9ef1755267254d90172f91423f5d.svg";
export { ForwardRef as ReactComponent };